import {get} from "@/api";
const state = {
    classList: ['疾病', 'DOT', '用药', '检查'],
    colorList: [
        'rgb(236, 245, 255)',
        'rgb(217, 236, 255)',
        'rgb(198, 226, 255)',
        'rgb(179, 216, 255)',
        'rgb(160, 207, 255)',
        'rgb(140, 197, 255)',
        'rgb(121, 187, 255)',
        'rgb(102, 177, 255)',
        'rgb(83, 168, 255)',
        'rgb(64, 158, 255)',
    ],

    ill_data: null,
    illUserData: [],

    articleData: null,

    ruleData: {},
    pushData: {},
    linePushData: {},
    textData: {},

    classifyList: []
};

const mutations = {
    // 编辑图文
    setArticleData(state, payload) {
        state.articleData = payload
    },

    // 推送规则
    setRuleData(state, payload) {
        state.ruleData = payload
    },
    // 定点推送
    setPushData(state, payload) {
        state.pushData = payload
    },
    setLinePushData(state, payload) {
        state.linePushData = payload
    },
    // 活动图文
    setTextData(state, payload) {
        state.textData = payload
    },

    setClassify(state, payload) {
        state.classifyList = payload
    }
};

const actions = {
    getClassify({ commit, dispatch, state }) {
        // 获取图文分类
        let params = {
            dict_name: '图文分类',
        };
        if(state.classifyList && state.classifyList.length > 0) return;
        get('/cdict/list', params).then(res => {
            commit("setClassify", res.data);
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}